// axios
import axios from 'axios'
import router from '@/router/index.js'
const baseURL = process.env.VUE_APP_BASE
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('access')}`
 const instance =  axios.create({
  baseURL
  // You can add your headers here
 })
  // Logout when token expiredz
  instance.interceptors.response.use(function (response) {
      return response
    }, function (error) {
      if (error.response.status === 401 || error.response.status === 403) {
        localStorage.removeItem('access')
        localStorage.removeItem('refresh')
        router.push('/login')
      }
      return Promise.reject(error)
    })
export default instance
